"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActorDisabledEventArgs = void 0;
const EventType_1 = require("../EventType");
class ActorDisabledEventArgs {
    constructor() {
        this.__type = EventType_1.EventType.ActorDisabled;
        this.__typeName = "ActorDisabled";
    }
}
exports.ActorDisabledEventArgs = ActorDisabledEventArgs;
